<template>
  <div class="wrap">
    <v-image src="/images/icons/no_content.png" />
    <p>{{title}}</p>
    <p class="blue">【切换城市】</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '当前列表为空'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  img {
    width: 50px;
    height: 50px;
  }
  p{
    color: $dark09;
    padding-left: 10px;
  }
  .blue{
    color: blue;
  }
}
</style>
